import { createWebHistory, createRouter } from "vue-router";
import Home from '../pages/Home.vue';
import HomeTwo from '../pages/HomeTwo.vue';
import HomeThree from '../pages/HomeThree.vue';
import Courses from '../pages/Courses.vue';
import CoursesList from '../pages/CoursesList.vue';
import CourseSidebar from '../pages/CourseSidebar.vue';
import CourseDetails from '../pages/CourseDetails.vue';
import Blog from '../pages/Blog.vue';
import BlogDetails from '../pages/BlogDetails.vue';
import About from '../pages/About.vue';
import AboutDuk from '../pages/About1.vue';
import Instructor from '../pages/Instructor.vue';
import InstructorDetails from '../pages/InstructorDetails.vue';
import EventDetails from '../pages/EventDetails.vue';
import Cart from '../pages/Cart.vue';
import Checkout from '../pages/Checkout.vue';
import SignIn from '../pages/SignIn.vue';
import SignUp from '../pages/SignUp.vue';
import ErrorPage from '../pages/ErrorPage.vue';
import Contact from '../pages/Contact.vue';
import CourseDetailsPage from '../pages/DynamicCourseDetails.vue';
import DynamicBlogDetails from '../pages/DynamicBlogDetails.vue';
import RahbariyatInfo from '../pages/RahbariyatInfo.vue';
import TuzilmaInfo from '../pages/Tuzilma.vue';
import FotosInfo from '../pages/Fotos.vue';
import VideosInfo from '../pages/Videos.vue';
import EventsInfo from '../pages/Events.vue';
import NewsInfo from '../pages/News.vue';
import Raqamlashtirish from '../pages/Raqamlashtirish.vue';
import FAQ from '../pages/FAQ.vue';
import Products from '../pages/Products.vue';
import newPage from '../pages/NewPage.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: Home,
        },
        {
            path: "/:name",
            name: "NewPage",
            component: newPage,
        },
        {
            path: '/home',
            component: Home,
        },
        {
            path: '/home-two',
            component: HomeTwo,
        },
        {
            path: '/home-three',
            component: HomeThree,
        },
        {
            path: '/courses',
            component: Courses,
        },
        {
            path: '/courses-list',
            component: CoursesList,
        },
        {
            path: '/faq',
            component: FAQ,
        },
        {
            path: '/courses-sidebar',
            component: CourseSidebar,
        },
        {
            path: '/course-details',
            component: CourseDetails,
        },
        {
            path: '/blog',
            component: Blog,
        },
        {
            path: '/blog-details',
            component: BlogDetails,
        },
        {
            path: '/about',
            component: About,
        },
        {
            path: '/aboutDuk',
            component: AboutDuk,
        },
        {
            path: '/instructor',
            component: Instructor,
        },
        {
            path: '/instructor-details',
            component: InstructorDetails,
        },
        {
            path: '/event-details/:id',
            component: EventDetails,
        },
        {
            path: '/cart',
            component: Cart,
        },
        {
            path: '/checkout',
            component: Checkout,
        },
        {
            path: '/login',
            component: SignIn,
        },
        {
            path: '/register',
            component: SignUp,
        },
        {
            path: '/errorPage',
            component: ErrorPage,
        },
        {
            path: '/contact',
            component: Contact,
        },
        {
            path: '/news-details/:id',
            component: CourseDetailsPage,
        },
        {
            path: '/blog-details/:id',
            component: DynamicBlogDetails,
        },
        {
            path: '/rahbariyat',
            component: RahbariyatInfo,
        },
        {
            path: '/tuzilma',
            component: TuzilmaInfo,
        },
        {
            path: '/raqamlashtirish',
            component: Raqamlashtirish,
        },
        {
            path: '/products/:name',
            component: Products,
        },
        {
            path: '/videos',
            component: VideosInfo,
        },
        {
            path: '/fotos',
            component: FotosInfo,
        }, {
            path: '/events',
            component: EventsInfo,
        },
        {
            path: '/news',
            component: NewsInfo,
        },

    ]
})

router.beforeEach((to, from, next) => {
    next();
    window.scrollTo(0, 0)
});

export default router
